import type { RouteConfig } from 'vue-router';

import {
  prozisAppAppleStoreURL,
  prozisAppGoogleStoreURL
} from '@/constants/application.constant';
import { ROUTES } from '@/constants/routes.constant';

const NotFoundScene = () =>
  import(
    /* webpackChunkName: "not-found" */ './scenes/not-found/not-found.scene.vue'
  );
const UnauthorizedScene = () =>
  import(
    /* webpackChunkName: "unauthorized" */ './scenes/unauthorized/unauthorized.scene.vue'
  );
const UseProzisStoreAppScene = () =>
  import(
    /* webpackChunkName: "use-prozis-store-app" */ './scenes/use-prozis-store-app/use-prozis-store-app.scene.vue'
  );
const EnableNotificationsScene = () =>
  import(
    /* webpackChunkName: "enable-notifications" */ './scenes/enable-notifications/enable-notifications.scene.vue'
  );
const AcceptTermsScene = () =>
  import(
    /* webpackChunkName: "accept-terms" */ './scenes/accept-terms/accept-terms.scene.vue'
  );

export default [
  {
    component: UnauthorizedScene,
    meta: { requiresAuth: true, roles: [] },
    name: ROUTES.APP.UNAUTHORIZED,
    path: '/403-forbidden'
  },
  {
    component: AcceptTermsScene,
    meta: { requiresAuth: true, roles: [] },
    name: ROUTES.APP.ACCEPT_TERMS,
    path: '/accept-terms'
  },
  {
    component: UseProzisStoreAppScene,
    meta: { requiresAuth: true, roles: [] },
    name: ROUTES.APP.USE_PROZIS_STORE_APP,
    path: '/use-prozis-store-app'
  },
  {
    beforeEnter: () => {
      const isAppleDevice = /iPad|iPhone|iPod/.test(navigator.userAgent);

      window.location.href = isAppleDevice
        ? prozisAppAppleStoreURL
        : prozisAppGoogleStoreURL;
    },
    name: ROUTES.APP.OPEN_PROZIS_STORE_APP,
    path: '/open-prozis-store-app'
  },
  {
    component: EnableNotificationsScene,
    meta: { requiresAuth: true, roles: [] },
    name: ROUTES.APP.ENABLE_NOTIFICATIONS,
    path: '/enable-notifications'
  },
  {
    component: NotFoundScene,
    meta: { requiresAuth: true, roles: [] },
    name: ROUTES.APP.NOT_FOUND,
    path: '*'
  }
] as RouteConfig[];
